module.exports = __webpack_public_path__ + "img/black-trash.9408e303.svg";